<template>
  <div>
    <Head :title="$t('models.election')"/>

    <h1 class="mb-8 text-3xl font-bold">{{ $t('models.election') }}</h1>

    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block mt-4 text-gray-700">{{ $t('ui.trashed') }}</label>
        <select v-model="form.trashed" class="form-select mt-1 w-full">
          <option :value="null"/>
          <option value="with">{{ $t('ui.with_trashed') }}</option>
          <option value="only">{{ $t('ui.only_trashed') }}</option>
        </select>
      </search-filter>
    </div>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="w-px"></th>
          <th class="pb-4 pt-6 px-4">{{ $t('fields.election.name') }}</th>
          <th class="pb-4 pt-6 px-4">{{ $t('fields.election.datetime_start') }}</th>
          <th class="pb-4 pt-6 px-4">{{ $t('fields.election.datetime_end') }}</th>
          <th class="pb-4 pt-6 px-4">{{ $t('fields.election.candidates_count') }}</th>
          <th class="w-px"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="election in elections" :key="election.uuid"
            class="hover:bg-gray-100 focus-within:bg-gray-100 cursor-pointer"
            @click="visit(route('member.elections.show', election.uuid))">
          <td class="px-2 py-4 border-t">
            <img v-if="election.cover_image" class="block -my-2 mx-2 w-8 h-8 rounded"
                 :src="election.cover_image" alt="election cover_image"/>
          </td>
          <td class="px-4 py-4 border-t">
            {{ election.name }}
          </td>
          <td class="px-4 py-4 border-t">
            {{ election.datetime_start }}
          </td>
          <td class="px-4 py-4 border-t">
            {{ election.datetime_end }}
          </td>
          <td class="px-4 py-4 border-t">
            {{ election.candidates_count }}
          </td>
          <td class="w-px border-t">
            <Link class="focus:text-indigo-500"
                  :href="route('member.elections.show', election.uuid)"
                  tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400"/>
            </Link>
          </td>
        </tr>
        <tr v-if="elections.length === 0">
          <td class="px-4 py-4 border-t" colspan="4">{{ $t('alerts.no_record_found') }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Layouts/Authenticated'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    elections: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(route('member.elections.index'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    visit(url) {
      this.$inertia.get(url)
    }
  },
}
</script>
